export const TICKET_STATUS_OPTIONS = [
  { label: "Open", value: "Open" },
  { label: "In Progress", value: "In Progress" },
];

export const actionOptions = (permission, ticketStatus = "Open") => {
  if (ticketStatus !== 'Closed') {
    return [
      {
        label: "View",
        value: "view",
        src: "",
        id: 1,
        disabled: false,
        tooltipText: "",
      },
      {
        label: "Mark As Closed",
        value: "markAsClosed",
        src: "",
        id: 2,
        disabled:false ,
        tooltipText: permission?.canWrite ? "" : "You don't have permission to perform this action",
      }
    ]
  }
  else if (ticketStatus === 'Closed') {
    return [
      {
        label: "Reopen",
        value: "reOpen",
        src: "",
        id: 1,
        disabled:false ,
        tooltipText: permission?.canWrite ? "" : "You don't have permission to perform this action",
      }
    ]
  }
    
  }

export const supportTicketFilterOptions = [
  { label: "Partner", value: false },
  { label: "Status", value: false },
  { label: "Date Raised", value: false },
  { label: "Date Closed", value: false },
  { label: "Sender", value: false }
];

export const FILTER_TICKET_STATUS_OPTIONS = [
  { label: "Open", value: "Open" },
  { label: "In Progress", value: "InProgress" },
  { label: "Closed", value: "Closed" },
  { label: "Reopen", value: "ReOpen" }
];